import { useGetOwnerContractorsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import { ServiceType } from '../../../enums/contractor';
import { OwnerContractor } from '../../../types/contractor';

export type PartnerServiceType =
    | ServiceType.Wellness
    | ServiceType.Catering
    | ServiceType.Workshop
    | ServiceType.Alcohol
    | ServiceType.Other;

export const PARTNER_SERVICE_TYPES: PartnerServiceType[] = [
    ServiceType.Catering,
    ServiceType.Alcohol,
    ServiceType.Wellness,
    ServiceType.Workshop,
    ServiceType.Other,
];

export const useOwnerContractors = (): OwnerContractor[] => {
    const loggedInUser = UserRole();
    const { data: contractors } = useGetOwnerContractorsQuery(
        loggedInUser.company,
        { skip: !loggedInUser?.company },
    );

    return contractors ?? [];
};

export const useOwnerContractorsByType = (
    serviceType: PartnerServiceType | null,
): OwnerContractor[] => {
    const contractors = useOwnerContractors();

    if (!serviceType) {
        return [];
    }

    return contractors.filter((c) => c?.services?.type === serviceType);
};
